/**
 * OpenReplay session recording — singleton tracker for this dashboard instance.
 * Records all authenticated sessions with coach identity tagging.
 * Only active when FRONTEND_OPENREPLAY_KEY is configured (mapped to REACT_APP_* for CRA).
 */

import Tracker from '@openreplay/tracker';

let tracker = null;

export function getTracker() {
  if (!tracker && process.env.REACT_APP_OPENREPLAY_KEY) {
    tracker = new Tracker({
      projectKey: process.env.REACT_APP_OPENREPLAY_KEY,
      ingestPoint: process.env.REACT_APP_OPENREPLAY_INGEST || 'https://replay.slamsports.ai/ingest',
      __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'development',

      // Privacy: obscure sensitive input values, respect DNT
      obscureTextEmails: true,
      obscureTextNumbers: false, // stats are core content — keep visible
      obscureInputEmails: true,
      obscureInputNumbers: true,
      obscureInputDates: true,
      defaultInputMode: 1, // obscured (structure visible, values hidden)
      respectDoNotTrack: false,

      // Console: errors only — warn can leak request context from error boundaries
      consoleMethods: ['error'],
      consoleThrottling: 30,

      // Network: capture request URLs + status codes, never payloads or auth headers
      network: {
        capturePayload: false,
        ignoreHeaders: ['Authorization', 'Cookie', 'X-Team-Password', 'X-API-Key'],
        failuresOnly: false,
        // Strip JWT tokens from SSO redirect URLs captured in network events
        sanitizer: (data) => {
          try {
            const url = new URL(data.url, window.location.origin);
            if (url.searchParams.has('token')) {
              url.searchParams.delete('token');
              data.url = url.toString();
            }
          } catch (e) { /* ignore malformed URLs */ }
          return data;
        },
      },

      // Performance + error capture
      capturePerformance: true,
      captureExceptions: true,
    });
  }
  return tracker;
}
